<template>
    <div
        class="collapse"
        :class="{ 'collapse--is-active': show }"
        :style="{ height }"
        @transitionend="onTransitionEnd"
    >
        <slot></slot>
    </div>
</template>

<script>
const EVENT_TOGGLE = 'toggle::collapse';
const EVENT_ACCORDION = 'collapse::accordion';
const EVENT_RECEIPT = 'collapse::toggle';

export default {
    props: {
        id: {
            type: String,
            default: null,
        },
        value: {
            type: Boolean,
            default: false,
        },
        accordion: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            show: this.value,
            height: null,
        };
    },
    watch: {
        value(v) {
            this.setValue(v);
        },
    },
    mounted() {
        this.listenOnRoot(EVENT_TOGGLE, this.handleToggleEvt);
        this.listenOnRoot(EVENT_ACCORDION, this.handleAccordionEvt);
    },
    methods: {
        setValue(value) {
            if (value) {
                this.doShow();
            } else {
                this.doHide();
            }
            this.emitState(value);
        },
        doShow() {
            this.height = 0;
            this.show = true;

            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.height = `${this.$el.scrollHeight}px`;
                    });
                });
            });
        },
        doHide() {
            this.height = `${this.$el.offsetHeight}px`;
            // delay change of this.show to after transition
            this.$nextTick(() => {
                requestAnimationFrame(() => {
                    requestAnimationFrame(() => {
                        this.height = 0;
                    });
                });
            });
        },
        handleToggleEvt(target) {
            if (target !== this.id) {
                return;
            }
            this.toggle();
        },
        handleAccordionEvt(openedId, accordion) {
            if (!this.accordion || accordion !== this.accordion) {
                return;
            }
            if (openedId === this.id) {
                if (!this.show) {
                    this.toggle();
                }
            } else if (this.show) {
                this.toggle();
            }
        },
        listenOnRoot(event, callback) {
            this.$root.$on(event, callback);
            this.$on('hook:beforeDestroy', () => {
                this.$root.$off(event, callback);
            });
            return this;
        },
        emitState(value) {
            this.$emit('input', value);
            this.$root.$emit(EVENT_RECEIPT, this.id, value);

            if (this.accordion && value) {
                this.$root.$emit(EVENT_ACCORDION, this.id, this.accordion);
            }
        },
        toggle() {
            this.setValue(!this.show);
        },
        onTransitionEnd() {
            if (this.height === 0) {
                this.show = false;
            }
            this.height = null;
        },
    },
};
</script>

<style lang="less">
.collapse {
    height: 0;
    overflow: hidden;
    transition: height .3s ease-in-out;
}

.collapse--is-active {
    height: auto;
}
</style>
